import { create } from "zustand";

export const useAcademicSetStore = create(
  (set) => ({
    schoolSet: [],
    isAllProductSelect: true,
    totalProductCount: 0,
    totalPrice: 0,
    totalSaveAmount: 0,

    setSchoolSet: (newData) => {
      set((state) => {
        const totalProductPrice = newData.reduce((acc, item) => {
          return acc + item.price;
        }, 0);

        const totalProductDiscountPrice = newData.reduce((acc, item) => {
          return acc + item.discountedPrice;
        }, 0);

        return {
          schoolSet: [...newData],
          totalProductCount: newData?.length,
          totalPrice: Math.round(totalProductDiscountPrice),
          totalSaveAmount:
            Math.round(totalProductPrice) -
            Math.round(totalProductDiscountPrice),
        };
      });
    },
    removeSchoolSet: () => {
      set((state) => {
        return {
          schoolSet: [],
          totalPrice: 0,
          totalSaveAmount: 0,
        };
      });
    },
    removeOneFromSchoolSet: (newData) => {
      set((state) => {
        const isSelected = state.schoolSet?.some(
          (item) => item?._id === newData?._id
        );

        const updatedSet = isSelected
          ? state.schoolSet?.filter((item) => item?._id !== newData?._id)
          : [...state.schoolSet, newData];

        const totalProductPrice = updatedSet.reduce((acc, item) => {
          return acc + item.price;
        }, 0);

        const totalProductDiscountPrice = updatedSet.reduce((acc, item) => {
          return acc + item.discountedPrice;
        }, 0);

        return {
          schoolSet: updatedSet,
          isAllProductSelect: isSelected
            ? false
            : state.totalProductCount === updatedSet?.length,
          totalPrice: Math.round(totalProductDiscountPrice),
          totalSaveAmount:
            Math.round(totalProductPrice) -
            Math.round(totalProductDiscountPrice),
        };
      });
    },

    setAllProductSelect: (newData) => {
      set((state) => {
        return {
          isAllProductSelect: newData,
        };
      });
    },
  }),
  {
    name: "academicStore",
    persist: (set, get) => ({
      getStorage: () => localStorage,
      onRehydrate: (state) => set(state, true),
      serialize: (state) => JSON.stringify(state),
      deserialize: (serializedState) => JSON.parse(serializedState),
    }),
  }
);
